import { createContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  /** What the user asked for, including "follow the system". */
  preference: ThemePreference;
  /** What is actually on screen right now. */
  theme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
  /** Flip between light and dark, resolving "system" first. */
  toggle: () => void;
}

/**
 * The context object lives apart from the provider component.
 *
 * React Fast Refresh can only hot-replace a module that exports components
 * exclusively; a context export in the same file forces a full reload on every
 * edit to the provider.
 */
export const ThemeContext = createContext<ThemeContextValue | null>(null);

/** Must match the key used by the inline bootstrap script in index.html. */
export const THEME_STORAGE_KEY = 'gointerview.theme';
